import { usePageMeta } from "./pageMeta.ts";
import { Support } from "./support.tsx";

const sectionStyle =
  "mb-6 text-text-secondary-light dark:text-text-secondary leading-relaxed text-sm";

export const About = () => {
  usePageMeta({
    title: "About | prompt2bot",
    description:
      "prompt2bot lets anyone create useful AI agents without writing code.",
  });
  return (
    <div className="max-w-2xl mx-auto my-10 p-6 rounded-lg shadow-md bg-surface-raised-light dark:bg-surface-raised border border-border-subtle-light dark:border-border-subtle text-text-primary-light dark:text-text-primary">
      <h1 className="text-2xl font-bold mb-8 text-center">About</h1>

      <p className={sectionStyle}>
        prompt2bot is built by Uri. The idea is simple: people should be able to
        create useful AI agents without writing code, managing infrastructure,
        or reading API docs.
      </p>

      <p className={sectionStyle}>
        You describe what you want in plain language, and the platform handles
        everything else: connecting to messaging channels, running tools,
        searching the web, executing code, managing memory and scheduling.
      </p>

      <div className="text-sm">
        <Support />
      </div>
    </div>
  );
};
